import Moment from 'react-moment';
import 'moment/locale/zh-hk';
import 'moment/locale/zh-cn';

export const updateLocale = (locale) => {
	let localeNew = 'zh-hk';

	switch (locale) {
		case 'zh-tw':
			localeNew = 'zh-hk';
			break;
		case 'zh-cn':
			localeNew = 'zh-cn';
			break;
		default:
			localeNew = 'en';
			break;
	}

	Moment.globalLocale = localeNew;
};